export function ovfHiden(isHiden) {
  let html = document.getElementsByTagName('html');
  let body = document.getElementsByTagName('body');
  if (isHiden) {
    html[0].className = "ovfHiden";
    body[0].className = "ovfHiden";
  } else {
    html[0].className = "";
    body[0].className = "";
  }
}

import config from './getConfig';
import arrayTool from './handelArray';

export default {
  exportFile(URL, params) {
    console.log(params);
    let url = config.apiURL + `${URL}?token=${JSON.parse(localStorage.getItem("user")).token}&export=1&`;
    let list = [];
    console.log(params);
    for (let key in params) {
      if (params.hasOwnProperty(key)) {
        console.log(key, params[key]);
        if (params[key]) {
          if (arrayTool.isArray(params[key])) {
            if (params[key].length) {
              list.push(`${key}[]=${params[key].join(`&${key}[]=`)}`)
            }
          } else {
            list.push(`${key}=${params[key]}`)
          }

        }
      }
    }

    url += list.join('&');
    console.log(url);
    window.open(url);
  }
}




// WEBPACK FOOTER //
// ./src/common/js/unit.js